const SHORT_CUSTOMER_ID_LENGTH = 8

export const formatShortCustomerId = (customerId?: string | null): string => {
  const id = (customerId || '').trim()

  return id.length > SHORT_CUSTOMER_ID_LENGTH ? id.slice(0, SHORT_CUSTOMER_ID_LENGTH) : id
}
